import styled from 'styled-components';

import { Box } from '@sternum/styled-system';

import { Shadows } from '../theme/constants';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  box-shadow: ${Shadows.DialogDarkMode};
  border-radius: 6px;
  gap: 4px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;

  & > div {
    display: flex;
    align-items: center;
  }
`;

export const Content = styled.div`
  padding: 24px;
  padding-top: 0;
`;
